export class RegisterPayload {
    companyId: number;
    username: string;
    name: string;
    password: string;
    confirmPassword: string;
    clientId: number;
    timestamp: number;
    lang: string;

    constructor(username: string, timestamp: number, appId: number, companyId: number = undefined) {
        this.username = username;
        this.timestamp = timestamp;
        companyId && (this.companyId = companyId);
        this.clientId = appId;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/user/payload/register-payload.ts